export const MINDSET_IMAGE_URL =
  'https://mento-space.nyc3.cdn.digitaloceanspaces.com/mindset/';
